__turbopack_context__.v({
  "down": "LanguageSelector-module__l4RgrG__down",
  "dropdownIcon": "LanguageSelector-module__l4RgrG__dropdownIcon",
  "langSelectorWrapper": "LanguageSelector-module__l4RgrG__langSelectorWrapper",
  "large": "LanguageSelector-module__l4RgrG__large",
  "regionIcon": "LanguageSelector-module__l4RgrG__regionIcon",
  "select": "LanguageSelector-module__l4RgrG__select",
  "selectedLangWrapper": "LanguageSelector-module__l4RgrG__selectedLangWrapper",
  "selector": "LanguageSelector-module__l4RgrG__selector",
  "small": "LanguageSelector-module__l4RgrG__small",
  "up": "LanguageSelector-module__l4RgrG__up",
});
